var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#2B8BFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5273_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97119 11.7441L9.53466 9.34082C9.53466 9.34082 7.19922 8.41307 6.11131 9.24463C5.02344 10.0767 4 12.3804 4 12.3804L5.15966 13.0528C5.15966 13.0528 6.62744 10.2085 7.97119 11.7441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2554 16.0283L14.6587 14.4648C14.6587 14.4648 15.5865 16.8003 14.7549 17.8882C13.9229 18.9756 11.6191 19.9995 11.6191 19.9995L10.9473 18.8399C10.9473 18.8399 13.7915 17.3721 12.2554 16.0283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.459 15.3403L10.0464 14.9281C9.29641 16.8774 7.53469 16.4653 7.53469 16.4653C7.53469 16.4653 7.12257 14.7035 9.07182 13.9535L8.65969 13.5414C7.57229 13.3539 6.18507 14.6659 5.95997 15.9404C5.73535 17.2148 5.69775 18.3017 5.69775 18.3017C5.69775 18.3017 6.78466 18.2646 8.05957 18.0395C9.33447 17.8144 10.6465 16.4277 10.459 15.3403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7881 4.21165C18.0869 3.4143 13.7788 4.90549 11.3828 8.08324C9.55714 10.5036 8.58008 12.1345 8.58008 12.1345L10.0303 13.5847L10.415 13.9695L11.8648 15.4192C11.8648 15.4192 13.4966 14.4426 15.917 12.6175C19.0938 10.2209 20.5855 5.91284 19.7881 4.21165ZM12.582 11.4177C12.1816 11.0173 12.1816 10.3679 12.582 9.96752C12.9825 9.56715 13.6314 9.56712 14.0322 9.96802C14.4326 10.3684 14.4326 11.0173 14.0322 11.4177C13.6314 11.8181 12.9824 11.8181 12.582 11.4177ZM14.9859 9.0144C14.4683 8.49634 14.4683 7.65746 14.9859 7.1399C15.503 6.6223 16.3423 6.6223 16.8599 7.1399C17.3775 7.65749 17.3775 8.49634 16.8599 9.0144C16.3423 9.53149 15.503 9.53149 14.9859 9.0144Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5273_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardIcon);
export default __webpack_public_path__ + "static/media/StandardIcon.a5f4044c794f75765ccb93b972e590b5.svg";
export { ForwardRef as ReactComponent };